module.exports = __webpack_public_path__ + "static/media/38.3059f2d0.jpg";